import { useContext, useMemo } from "react";
import { RoundedCheckBox, ListItemChecked } from "../icons";
import { Table, Button, Spinner } from "react-bootstrap";
import ArchiveCardItem from "./archive_card_item";
import { RecycleBinContext } from "../../contexts/RecycleBinContext";
import useTrashBinHook from "./useTrashBinHook";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useCardImageLoaderHook } from "../../hooks/useCardImageLoaderHook";
import { ContentGroupPopupContext } from "../../contexts/ContentGroupPopupContext";
import InfiniteScroll from "react-infinite-scroll-component";
import { history } from "../../helpers";
import { DismissablePopup } from "../popup";

const TrashBin = ({
  organization_id
}) => {
  const {
    selectedItems, setSelectedItems,
    selectAll,setSelectAll,
    addCardToSelection,
    removeCardToSelection,
    handleSelectAll,
    handleUnselectAll,

    showDeleteModal, setShowDeleteModal,
    handleDelete,

    showDeleteAllModal, setShowDeleteAllModal,

    showRestoreModal, setShowRestoreModal,
    handleRestore,

    handleResetCache,

    page,
    loadBin,
    loadMore,
    hasMore
  } = useTrashBinHook({
    organization_id
  });
  const selectedItemsSet = useMemo(() => new Set(selectedItems), [selectedItems]);
  const { deleted_content_groups, total_deleted_count } = useSelector((s) => s.content_group);
  const { loading:organization_loading } = useSelector((s) => s.organization);
  const dispatch = useDispatch();
  const querySelector = '#trashbinTable > tbody > tr > td.card_title_cell > div.card_container > div.image_div';
  const { setContentGroupPopUp } = useContext(ContentGroupPopupContext);

  const image_hook = useCardImageLoaderHook({
    organization_id,
    dependency: deleted_content_groups,
    querySelector,
  })

  let reycle_bin_context = {
    addCardToSelection,
    removeCardToSelection,
    setContentGroupPopUp,
    selectAll
  }

  const popupTitle = useMemo(() => selectAll ? `${total_deleted_count} cards` : `${selectedItems.length} card${selectedItems.length > 1 ? 's' : ''}`,[total_deleted_count, selectAll, selectedItems]);
  const restoreMessage = useMemo(() => selectAll || selectedItems.length > 1   ? 'these cards' : 'this card',[selectAll, selectedItems]);
  const is_recycle_bin_empty = useMemo(() =>  deleted_content_groups.length === 0, [deleted_content_groups]);
  const selectedItemText = useMemo(() => selectAll ? `Total of ${total_deleted_count}` : `Total of ${selectedItems.length}`, [total_deleted_count, selectAll, selectedItems, deleted_content_groups]);
  const deletedSelectedItemText = useMemo(() => selectAll ? `all ${total_deleted_count}` : selectedItems.length, [total_deleted_count, selectAll, selectedItems, deleted_content_groups]);

  useEffect(() => {
    if(organization_id){
      loadBin(page);
    }
    return () => {
      
    };
  }, []);

  return (
    <RecycleBinContext.Provider value={reycle_bin_context}>
      <div className="page_subheader mb-3 d-lg-flex align-items-center justify-content-between">
        <p className="mb-lg-0">
          Restore any card deleted in the last 30 days.
        </p>
        <div className="d-flex gap-2">
          <Button 
            className="px-3"
            variant="" 
            size="sm"
            onClick={handleResetCache}
            disabled={organization_loading}
          >
            Reset Cache
          </Button>
          <Button 
            className="px-3"
            variant="" 
            size="sm"
            onClick={() => history.goBack()}
          >
            Back
          </Button>
        </div>
      </div>
      <div className="trash_bin_layout px-4 py-2">
        <InfiniteScroll
            dataLength={deleted_content_groups?.length}
            hasMore={hasMore}
            loader={
              <div className="clearfix">
                <div className="spinner-container">
                  <Spinner animation="border" />
                </div>
              </div>
            }
            next={loadMore}
            scrollableTarget="mainContainer"
          >
            
            <Table 
              id={'trashbinTable'}
            >  
              <thead>
                <tr>
                  <th 
                    style={{ width: 10 }}
                    className="text-right p-1"
                  >
                    {
                      !is_recycle_bin_empty && 
                        <>
                          {
                            selectAll ?
                              <div
                                className="cursor-pointer"
                                style={{width: 20, height: 20}}
                                onClick={handleUnselectAll}
                              >
                                <ListItemChecked 
                                  color={'#FF3B30'}
                                  height={20}
                                  width={20}
                                />
                              </div>
                            :
                              <div
                                className="cursor-pointer"
                                style={{width: 20, height: 20}}
                                onClick={handleSelectAll}
                              >
                                <RoundedCheckBox 
                                  color={'#D9D9D9'}
                                  height={20}
                                  width={20}
                                  className={'checkbox-hoverable'}
                                />
                              </div>
                          }
                        </>
                    }
                  </th>

                  {
                    selectAll || selectedItems.length > 0 ?
                      <th
                        colSpan={5}
                        className="pr-0"
                      >
                        <div class="info_card mb-0 px-3 py-1 w-100 d-flex justify-content-between align-items-center">
                          <span>
                            {`${selectedItemText} selected`}
                          </span>
                          
                          <div>
                            <Button 
                              className="mr-2"
                              variant="" 
                              size="sm"
                              onClick={() => setShowRestoreModal(true)}
                            >
                              Restore
                            </Button>

                            <Button 
                              className=""
                              variant="" 
                              size="sm"
                              onClick={() => setShowDeleteModal(true)}
                            >
                              Delete
                            </Button>
                          </div>
                        </div>
                      
                      </th>
                    :
                      <>
                        <th
                            className="card_title_header"
                          >
                            Card
                          </th>
                          <th 
                            className="text-center"
                          >
                            Workspace
                          </th>
                          <th 
                            className="text-center"
                          >
                            Deleted by
                          </th>
                          <th 
                            className="text-center"
                          >
                            Date Deleted</th>
                          <th className="text-center">
                            <span style={{marginRight: '28.8px'}}>Actions</span>
                          </th>
                      </>
                  }
                </tr>
              </thead>
              <tbody>
                  {
                    deleted_content_groups?.map((card, index) => (
                      <tr key={card.id}>
                        <ArchiveCardItem 
                          data={card}
                          selected={selectedItemsSet?.has(card)}
                          organization_id={organization_id}
                        />
                      </tr>
                    ))
                  }
                </tbody>
            
            </Table>
            
          </InfiniteScroll>

        {/* Delete Card */}
        <DismissablePopup 
          title={`Delete ${deletedSelectedItemText} cards`}
          message={'Are you sure? This action cannot be undone.'}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={() => {
            const all_records_override = null;
            const refreshBin = true;
            handleDelete(all_records_override, refreshBin)

          }}
          show={showDeleteModal}
        />

        {/* Restore Cards */}
        <DismissablePopup 
          title={`Restore`}
          message={`Put ${restoreMessage} back in its original stage?`}
          onClose={() => setShowRestoreModal(false)}
          onConfirm={() => {
            const all_records_override = null;
            const refreshBin = true;
            handleRestore(all_records_override, refreshBin)
          }}
          show={showRestoreModal}
          confirmBtnVariant={'success'}
        />
      </div> 
    </RecycleBinContext.Provider>
  );
};

export default TrashBin;